import { years } from 'components/MainComponent/constants'
import { party_list, party_sort } from 'components/MainComponent/party_colors'
import { Select } from 'components/Select'
import { useState } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

const parties = party_list
const sortingArr = party_sort

export const UserSelection = ({
  locale,
  activeParty,
  activeYear,
  handlePartyChange,
  handleYearChange,
  handleMunicipalityChange,
  colorMode = 'light',
}: {
  locale: 'de' | 'fr'
  activeParty: string
  activeYear: number
  handlePartyChange: (value: any) => void
  handleYearChange: (value: any) => void
  handleMunicipalityChange: (value: any) => void
  colorMode?: 'light' | 'dark' | undefined
}) => {
  const { t } = useTranslation()
  const [currentOpen, setCurrentOpen] = useState<
    'year' | 'party' | 'municipality' | undefined
  >()

  // let parties_sorted = [...parties]
  let parties_sorted = [...parties].filter((p) => !['CVP', 'BDP'].includes(p))
    .reverse()
    .sort((a: string | number, b: string | number) => {
      if (a === 'Schweiz') return -1
      if (b === 'Schweiz') return 1
      return sortingArr.indexOf(a + '') - sortingArr.indexOf(b + '')
    })

  let years_reverse = [...years].reverse()

  return (
    <UserSelectionRoot>
      <UserInputContainer>
        <Select
          label={t("swissmap:selectParty")}
          colorMode={colorMode}
          isOpen={currentOpen === 'party'}
          // disabled={currentOpen !== undefined && currentOpen !== 'party'}
          setOpen={(value) => setCurrentOpen(value ? 'party' : undefined)}
          entries={[
            // { label: 'Schweiz', value: 'Schweiz' },
            ...parties_sorted.map((m) => ({ label: m, value: m })),
          ]}
          onChange={handlePartyChange}
          current={activeParty}
        />
        <Select
          label={t("swissmap:selectYear")}
          colorMode={colorMode}
          isOpen={currentOpen === 'year'}
          setOpen={(value) => setCurrentOpen(value ? 'year' : undefined)}
          // disabled={currentOpen !== undefined && currentOpen !== 'year'}
          entries={years_reverse.map((m) => ({ label: m, value: m }))}
          onChange={handleYearChange}
          current={activeYear}
        />

        {/* <SearchWrapper>
          <MunicipalitySearch
            // customMunicipalities={customMunicipalities as any}
            locale={locale}
            dedupe
            maxResults={4}
            hideTooltip
            resetOnSelect
            placeholder={
              locale === 'fr' ? 'Nom de la commune' : 'Gemeindesuche'
            }
            onSelectionHandler={(selectedMunicipality: Municipality) => {
              if (handleMunicipalityChange) {
                handleMunicipalityChange(selectedMunicipality.GDENR)
              }
            }}
          />
        </SearchWrapper> */}
      </UserInputContainer>
    </UserSelectionRoot>
  )
}

const UserSelectionRoot = styled.div`
  margin-bottom: 60px;
`

const UserInputContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  position: relative;
  gap: 10px;
  top: 0;
  left: 0;
  justify-content: center;
  align-items: center;
  margin-top: 15px;

  .municipality-search {
    @media screen and (max-width: 711px) {
      width: 100%;
    }
  }
`
const SearchWrapper = styled.div`
  flex: 0 0 100%;
  display: flex;
  justify-content: center;
`
